import { compose, withState } from "recompose";
import * as hoc from "modules/user/auth/hoc";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import * as selectors from "modules/user/auth/selectors";
import View from "./View";

export default compose(
  hoc.withUserData,
  withState("selectedSlot", "setSelectedSlot", null),
  connect(
    createStructuredSelector({
      isAuthenticated: selectors.isAuthenticated
    })
  )
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ChooseTime/Provider.js